import React, { useState, useEffect,  useRef } from 'react';
import Typewriter from 'typewriter-effect';
import { Elements, PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

import PrivateBetaModal from '../components/PrivateBetaModal';

// graphics
import mockup_1 from '../assets/250ml_mockup_1.png';
import mockup_1a from '../assets/250ml_mockup_1a.png'; 
import mockup_2a from '../assets/250ml_mockup_2a.png';
import rack_2 from '../assets/rack_2.png'

const Home = () => {

    const [readyForNextTyping, setReadyForNextTyping] = useState(false);
    const [typingComplete, setTypingComplete] = useState(false);

    useEffect(() => {
      setTimeout(() => {
        setTypingComplete(true);
      }, 1000);
    }, [])

    const intervalRef = useRef(null);
  
    /* Autoplay for image carousel */
    useEffect(() => {
        // We only start the image carosel interval if the typing is done, thereby ensuring first image is always shown first
        if (!typingComplete) return;

        intervalRef.current = setInterval(next, 5000);
        return () => clearInterval(intervalRef.current);
    }, [typingComplete]);

    /* Swipe refs for swiping on carousel */
    const touchStartX = useRef(null);
    const SWIPE_TOLERANCE = 50;          // px needed to trigger a change

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
        clearInterval(intervalRef.current);          // pause autoplay while swiping
    };

    const handleTouchEnd = (e) => {
        const delta = e.changedTouches[0].clientX - touchStartX.current;
        if (Math.abs(delta) > SWIPE_TOLERANCE) {
            delta < 0 ? next() : prev();               // left swipe → next, right → prev
        }
        /* restart autoplay */
        intervalRef.current = setInterval(next, 5000);
    };

    const images = [mockup_1a, mockup_2a];
    const [slide, setSlide] = useState(0);

    const next  = () => setSlide((i) => (i + 1) % images.length);
    const prev  = () => setSlide((i) => (i - 1 + images.length) % images.length);

    const homeRef = useRef(null);
    const [visible, setVisible] = useState(false);   // ← fire once

    /* When 30 % of container is visible, flip `visible` to true */
    useEffect(() => {
        const el = homeRef.current;
        if (!el) return;

        const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                setVisible(true);
                observer.disconnect();          // run only once
            }
        },
        { threshold: 0.30 }                 // tweak as you like
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    const anim = (cls) => (visible ? cls : 'opacity-0');   // or 'animate-none'

    const [modal, setModal] = useState('beta');

    return (
      <>
        {/* ───────── Overlay + modal ───────── */}
        {/* {modal && modal === 'beta' && (
          <>
            <div className="fixed inset-0 z-40 animate-fade animate-delay-[560ms]" />
            <PrivateBetaModal
              onUnlock={() => setModal(null)}
              class="z-50"          // give the modal a higher z if needed
            />
          </>

        )} */}

        <div ref={homeRef} className={anim("inset-0 flex flex-1 flex-col w-full min-h-screen max-w-6xl mx-auto px-6 xl:px-0 pb-12 pt-6 overflow-hidden")}>
          <div className={anim("flex flex-col sm:flex-row sm:space-x-16 items-start justify-start space-y-4 sm:space-y-0 w-full h-full")}>
                <div class="flex flex-row w-full h-full items-start justify-center space-x-2">
                  <div class="flex w-full items-center justify-start">
                    {/* <div class={anim(`absolute inset-0 bg-white animate-flip-down`)}>
                      <div class={anim(`absolute inset-0 bg-white ${!typingComplete ? 'opacity-100' : 'opacity-0'} transition-opacity duration-[2000ms]`)}>
                        <div class="flex w-1/2">
                            <svg class="w-full h-full text-cowjuice-black z-20" id="Layer_2" data-name="Layer 2" viewBox="0 0 119.06 300.64">
                                <g id="Layer_1-2" data-name="Layer 1">
                                    <g>
                                        <path class={anim("fill-current animate-fade-right animate-delay-[350ms]")} d="M66.88,292.71c18.83,0,22.64-4.86,22.81-23.57h25.57c-.17,24.28-8.12,31.5-57.02,31.5s-55.29-8.76-55.47-32.92h42.68c.17,21.67,2.94,24.99,21.43,24.99Z"/>
                                        <path class={anim("fill-current animate-fade-right animate-delay-[300ms]")} d="M112.32,240.72c0,18.48-15.21,21.2-65.66,21.2-27.3,0-45.79-2.84-45.79-18.12,0-16.34,5.53-21.2,59.96-21.2,41.99,0,51.49,6.63,51.49,18.12ZM40.61,243.32c0,10.42,9.16,11.72,24.36,11.72s24.71-2.61,24.71-11.72-7.43-12.79-24.71-12.79-24.36,2.49-24.36,12.79Z"/>
                                        <path class={anim("fill-current animate-fade-right animate-delay-[250ms]")} d="M113.01,186.6c-4.32.71-27.47,2.96-27.47,4.74,0,2.01,26.26,4.62,31.62,5.21v14.57l-110.42,8.29v-7.7c29.2-2.72,45.27-4.15,54.6-5.45,7.95-1.18,11.4-1.42,11.4-3.67,0-2.72-13.31-4.62-61.69-7.58v-7.22c23.15-1.78,36.29-2.61,43.89-3.67,6.74-.83,10.02-.95,10.02-3.2,0-3.32-7.78-5.09-57.89-10.19v-6.51l105.92,9.24v13.15Z"/>
                                    </g>
                                    <g>
                                        <path class={anim("fill-current animate-fade-right animate-delay-[200ms]")} d="M119.06,158.1h-31.79c-.52-10.78-6.39-13.5-24.54-13.5H0v-8.53h53.57c54.95,0,65.14,2.01,65.49,22.03Z"/>
                                        <path class={anim("fill-current animate-fade-right animate-delay-[150ms]")} d="M118.02,111.91c0,16.82-20.74,17.65-108.51,17.65v-8.65c57.19-.12,69.81-1.18,69.81-9.47,0-4.38-2.59-7.34-14.34-8.76-5.7-.71-13.13-1.07-22.81-1.18-9.33-.12-20.91-.12-36.81-.12v-6.87c92.62,0,112.66,1.07,112.66,17.41Z"/>
                                        <path class={anim("fill-current animate-fade-right animate-delay-[100ms]")} d="M4.84,87.4v-9.24h106.79v9.24H4.84Z"/>
                                        <path class={anim("fill-current animate-fade-right animate-delay-[50ms]")} d="M66.87,63.24c18.83,0,22.64-4.86,22.81-23.57h25.57c-.17,24.28-8.12,31.5-57.02,31.5S2.94,62.41,2.76,38.25h42.68c.17,21.67,2.94,24.99,21.43,24.99Z"/>
                                        <path class={anim("fill-current animate-fade-right animate-delay-[0ms]")} d="M7.6,31.15V.71h35.77c0,22.62,1.73,23.57,8.29,23.57,7.43,0,9.68-.71,9.68-20.96h11.23c0,18.59,1.9,19.9,9.85,19.9s9.68-1.18,9.85-23.21h22.64v31.15H7.6Z"/>
                                    </g>
                                </g>
                            </svg>
                        </div>
                      </div>
                    </div> */}

                    <div 
                        className={anim(`relative flex-1 h-full w-full rounded-sm overflow-hidden ${!typingComplete ? 'opacity-0' : ' opacity-100 border-[0.5px] border-black'} transition-opacity duration-[2000ms] select-none`)}
                        onTouchStart={handleTouchStart}
                        onTouchEnd={handleTouchEnd}
                    >
                        {/* slide track */}
                        <div
                            className={`flex w-full h-full transition-transform duration-500 ${!typingComplete ? 'opacity-0' : 'opacity-100'} transition-opacity duration-[2000ms] ease-in-out`}
                            style={{ transform: `translateX(-${slide * 100}%)` }}
                        >
                            {images.map((src, i) => (
                                <img
                                    key={i}
                                    src={src}
                                    alt={`Cow Juice mock‑up ${i + 1}`}
                                    className="flex-shrink-0 w-full"
                                />
                            ))}
                        </div>

                        {/* arrows */}
                        <button
                            onClick={() => { prev(); clearInterval(intervalRef.current); }}
                            className={`${!typingComplete ? 'hidden' : 'absolute'} top-1/2 left-2 -translate-y-1/2 bg-neutral-100 hover:bg-white border-[0.25px] border-black rounded-xl w-8 h-6 flex items-center justify-center font-bold`}
                            aria-label="Previous image"
                        >‹</button>

                        <button
                            onClick={() => { next(); clearInterval(intervalRef.current); }}
                            className={`${!typingComplete ? 'hidden' : 'absolute'} top-1/2 right-2 -translate-y-1/2 bg-neutral-100 hover:bg-white border-[0.25px] border-black rounded-xl w-8 h-6 flex items-center justify-center font-bold`}
                            aria-label="Next image"
                        >›</button>

                        {/* dots + progress bar */}
                        <div className={`${!typingComplete ? 'hidden' : 'absolute'} bottom-2 inset-x-0 flex justify-center gap-1`}>
                            {images.map((_, i) => (
                            <div
                                key={i}
                                onClick={() => setSlide(i)}
                                className="relative w-8 h-2 border-[0.25px] border-black rounded-full overflow-hidden cursor-pointer"
                            >
                                {/* this inner bar animates only on the active slide */}
                                <div
                                    className={`absolute inset-0 ${slide === i ? "animate-progress" : "w-0"} bg-black`}
                                />
                            </div>
                            ))}
                        </div>
                    </div>
                  </div>
                </div>
                
                <div className={anim("flex flex-col w-full h-full items-center justify-start space-y-4")}>
                  <div class={anim(`flex flex-col border-[0.5px] border-black bg-white rounded-sm p-2 space-y-2 w-full animate-fade animate-delay-500`)}>
                      <p class="w-full font-mono uppercase font-bold text-xs text-left">
                        <Typewriter
                          options={{
                            delay: 30,
                            cursor: '',
                            autoStart: true,
                          }}
                          onInit={(typewriter) => {
                            typewriter
                              .pauseFor(750)
                              .typeString("The world's first can of <span class='text-cowjuice-bronze border-[0.5px] border-cowjuice-bronze rounded-sm px-[2px]'>Ultra-Retorted™</span> Milk.")
                              .callFunction(() => {
                                setReadyForNextTyping(true);
                              })
                              .start()
                          }}
                        />
                      </p>
                      {readyForNextTyping && (
                        <div class="flex flex-col w-auto items-start justify-start mt-2 space-y-2 text-[10px] sm:text-xs leading-3 sm:leading-normal uppercase font-mono">
                          <div class={anim("flex flex-col space-y-1 text-left bg-transparent rounded-sm border-[0.5px] border-black text-black p-1 animate-flip-up animate-delay-[375ms]")}>
                            <p class="sm:text-[11px] leading-3 font-mono text-black font-bold ">Ultra-Retorted Milk™, Def. (1a):</p>
                            <p class="sm:text-[11px] leading-3">The revolutionary pasteurization process which caramelizes milk to create an ever-so-slightly sweet can of lactose-free cow juice.<sup>[1]</sup></p>
                          </div>
                        </div>
                      )}
                      
                  </div>
                  {typingComplete && (
                    <>
                      <div class={anim("flex flex-col items-center justify-center w-full space-y-2")}>
                        <img src={rack_2} class={anim("hidden sm:block border-[0.5px] border-black rounded-sm animate-fade-left animate-delay-[200ms]")}/>
                        <button
                          onClick={() => window.location.href = '/shopify/products'} 
                          class={anim("flex w-full px-2 py-3 sm:p-4 rounded-sm bg-black text-white hover:bg-neutral-700 border-[0.5px] border-black animate-flip-up transition-colors duration-500")}
                        >
                          <p class="font-bold text-xs font-mono uppercase">Order Cow Juice — Available in Private Beta<sup>[2]</sup></p>
                        </button>
                        <button
                          onClick={() => window.location.href = '/ultra-retorted-milk'} 
                          class={anim("flex w-full px-2 py-3 sm:p-4 rounded-sm bg-white text-black hover:bg-neutral-200 border-[0.5px] border-black animate-flip-down animate-delay-[250ms] transition-colors duration-500")}
                        >
                          <p class="font-bold text-xs font-mono uppercase">Explore <span class="text-cowjuice-bronze border-cowjuice-bronze border-[0.5px] rounded-sm px-[2px]">retortation™</span></p>
                        </button>
                      </div>

                    {/* Footnotes below. */}
                    <div class={anim("flex flex-1 flex-col w-full h-full items-center justify-end space-y-2 animate-fade")}>
                      <div class="flex flex-col w-full items-center justify-center space-y-2 py-2 border-t-[0.5px] border-black opacity-60">
                        <p class="text-[10px] leading-3 font-mono text-left w-full inline animate-flip-up uppercase"><sup>[1]</sup> This marks phase I of the retort revolution, which you can join by purchasing Cow Juice. Every order includes an entry certificate into the wonderful world of <span class="text-cowjuice-rd">retortation</span>, A.K.A. <span class="text-cowjuice-ed">retort-land</span>.</p>
                        <p class="text-[10px] leading-3 font-mono text-left w-full inline animate-flip-down uppercase"><sup>[2]</sup> Selectively available now in private-beta, hand-packed by Cow Juice Man.</p>
                        <p class="text-[10px] leading-3 font-mono text-left w-full inline animate-flip-down uppercase"><sup>[3]</sup> Ultra-Retorted Milk is a patent pending invention of Cow Juice Inc. Dare to rip and you will be juiced.</p>
                      </div>
                    </div>

                    {/* ─── Legal ─────────────────────────────────────────────────────── */}
                    {/* <p className="font-mono py-2 text-[10px] leading-3 uppercase opacity-60 border-t-[0.5px] border-black">
                        Ultra‑Retorted™, Retortation™, & Cow Juice™ are trademarks of Cow Juice Inc. Rip 'em and we'll retort you with the next batch of Cow Juice.
                    </p> */}
                    </>
                  )}
                  
                </div>
              </div>
          </div>
      </>
    );
};

export default Home;
